<footer class="footer">
  <div class="footer-content">
    <p>
      The European Commission’s support for the production of this publication does not constitute an endorsement of the contents, 
      which reflects the views only of the authors, and the Commission cannot be held responsible for any use which may be made 
      of the information contained therein.<br><br>
      Project number: 2024-1-FR01-KA220-VET-000245350 
    </p>
    <img src="assets/logo.png" alt="EU Logo" class="footer-logo" />
  </div>
</footer>
